import React from 'react';

interface RadioButtonProps {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  className?: string;
}

const RadioButton: React.FC<RadioButtonProps> = ({
  checked,
  onChange,
  disabled = false,
  className = '',
}) => {
  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div 
      className={`relative inline-block w-5 h-5 cursor-pointer ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}
      onClick={handleClick}
    >
      <div className="absolute inset-0 w-5 h-5 border-2 border-brand-primary rounded-full"></div>
      {checked && (
        <div className="absolute inset-0 m-1 bg-brand-green rounded-full"></div>
      )}
    </div>
  );
};

export default RadioButton;
